// validate email
const validateEmail = (email) => {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

const validateConfirmEmail = (emailEl) => {
    const equalToName = emailEl.getAttribute('data-equal-name');
    const confirmEmailEl = document.querySelector(`input[name="${equalToName}"]`);
    if (emailEl.value === confirmEmailEl.value) {
        validate.removeError(confirmEmailEl);
    }
    return emailEl.value === confirmEmailEl.value;
}

// validate tel
const validatePhoneUK = (phone_number) => {
    return phone_number.length > 9 && phone_number.match(/^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?\#(\d{4}|\d{3}))?$/);
}

// validate date of birth
const validateBirth = (DOBFormElement) => {
    const date = DOBFormElement.value;
    const maxDate = DOBFormElement.getAttribute('data-max-date') === 'today' ? new Date() : new Date(DOBFormElement.getAttribute('data-max-date'));
    const dateSplit = date.split('/');
    const DOB = new Date(dateSplit[1] + '/' + dateSplit[0] +'/' + dateSplit[2]).getTime();
    const currDate = maxDate ? maxDate.getTime() : new Date().getTime();
    return currDate > DOB;
};

// validate postcode uk
const validatePostcode = (postcode) => {
    const re = /^[A-Z]{1,2}[0-9]{1,2} ?[0-9][A-Z]{2}$/i;
    return re.test(postcode);
}

const clearAdditionalDetailErrors = (additionalDetailEl) => {
    if (!additionalDetailEl) return;

    const fields = additionalDetailEl.querySelectorAll('input, textarea, select');
    for (const field of fields) {
        field.setAttribute('aria-invalid', 'false');
    }

    const radioGroups = additionalDetailEl.querySelectorAll('.input-radio-group');
    for (const radioGroup of radioGroups) {
        const radioFields = radioGroup.querySelectorAll('input[type="radio"]');
        for (const radioField of radioFields) {
            radioField.setAttribute('aria-invalid', 'false');
        }

        const radioWrapper = radioGroup.closest('.form-group, .form-field');
        if (radioWrapper) {
            radioWrapper.classList.remove('error');
        }
    }

    const errorContainers = additionalDetailEl.querySelectorAll('.error');
    for (const container of errorContainers) {
        container.classList.remove('error');
    }

    const errorEls = additionalDetailEl.querySelectorAll('.error-message');
    for (const errorEl of errorEls) {
        errorEl.remove();
    }
};

const setAdditionalDetailVisibility = (additionalDetailEl, isVisible) => {
    if (!additionalDetailEl) return;

    additionalDetailEl.classList.toggle('show', isVisible);
    additionalDetailEl.setAttribute('aria-hidden', isVisible ? 'false' : 'true');

    if (!isVisible) {
        clearAdditionalDetailErrors(additionalDetailEl);
    }
};

/**
 * Select element validation
 * @param selectFormElement
 * @returns {boolean}
 */
 const formCheckSelect = (selectFormElement) => {
    let error = false;
    const value = selectFormElement.value;

    // Note: show/hide the detail input for selects that have .need-additional-detail
    const hasAdditionalDetail = selectFormElement.classList.contains('need-additional-detail');
    if(hasAdditionalDetail) {
        const needDetailOptions = selectFormElement.querySelectorAll('.trigger-additional-detail');
        const parentFromField = selectFormElement.closest('.form-field');
        const nextAdditionalDetail = parentFromField.nextSibling.nextElementSibling;

        const needDetailOptionValues = [];
        for(const option of needDetailOptions){
            needDetailOptionValues.push(option.innerText);
        }

        if(needDetailOptionValues.includes(value)) {
            setAdditionalDetailVisibility(nextAdditionalDetail, true);
        } else {
            setAdditionalDetailVisibility(nextAdditionalDetail, false);
        }
    }

    const hasOptions = selectFormElement.classList.contains('need-options');
    if(hasOptions) {
        const ctrlToShow = selectFormElement.options[selectFormElement.selectedIndex].getAttribute('aria-controls');

        for(const option of selectFormElement.options){
            const currentOption = option.value
            if(currentOption) {
                const hiddenEl = document.querySelector('#' + option.getAttribute('aria-controls'));
                const childEls = hiddenEl.querySelectorAll('.form-field:not([aria-hidden])');

                if (hiddenEl.id == ctrlToShow) {
                    setAdditionalDetailVisibility(hiddenEl, true);
                    for(const child of childEls) {
                        child.classList.remove('additional-detail');
                    }
                } else {
                    setAdditionalDetailVisibility(hiddenEl, false);
                    for(const child of childEls) {
                        child.classList.add('additional-detail');
                    }
                }
            }
        }
    }

    if (value !== '' && parseInt(value) !== -1) {
        error = true;
    }
    return error;
}

/**
 * Radio elements validation
 * @param selectFormElement
 * @returns {boolean}
 */
const formCheckRadio = (radioFormElement) => {
    var radioName = radioFormElement.getAttribute('name');
    var radioOptions = document.querySelectorAll('[name="' + radioName + '"]');


    // Note: show/hide the detail input for radios that have .need-additional-detail
    const hasAdditionalDetail = radioFormElement.parentElement.parentElement.classList.contains('need-additional-detail');
    const showDetailTextareaWhenNo = radioFormElement.parentElement.parentElement.classList.contains('show-detail-textarea-when-no');

    if(hasAdditionalDetail) {
        const optionValue = radioFormElement.value;
        const parentFromField = radioFormElement.closest('.form-field');
        const nextAdditionalDetail = parentFromField.nextSibling.nextElementSibling;

        if(!showDetailTextareaWhenNo) {
            // Note: show the detail textarea when the users choose "Yes"
            if(optionValue === "yes" && radioFormElement.checked) {
                setAdditionalDetailVisibility(nextAdditionalDetail, true);
            } else if(optionValue === "no" && radioFormElement.checked) {
                setAdditionalDetailVisibility(nextAdditionalDetail, false);
            }
        } else {
            // Note: show the detail textarea when the users choose "No"
            if(optionValue === "no" && radioFormElement.checked) {
                setAdditionalDetailVisibility(nextAdditionalDetail, true);
            } else if(optionValue === "yes" && radioFormElement.checked) {
                setAdditionalDetailVisibility(nextAdditionalDetail, false);
            }
        }

    }

    // loop all radio items with this name
    var error = false;
    for (const radioOption of radioOptions) {
        if (radioOption.checked == true) {
            error = true;
        }
    }
    return error;
}

/**
 * Checkbox elements validation
 * @param selectFormElement
 * @returns {boolean}
 */
const formCheckbox = (checkboxFormElement) => {
    var error = false;
    const checkboxGroup = checkboxFormElement.parentElement.parentElement;

    // check if the checkboxFormElement is in the .checkbox-group
    if(checkboxGroup.getAttribute("type") === "checkbox-group") {
        const checkboxOptions = checkboxGroup.querySelectorAll('input[type="checkbox"]');

        // loop all checkbox items
        for (const checkboxOption of checkboxOptions) {
            if (checkboxOption.checked == true) {
                error = true;
            }
        }
    } else {
        if (checkboxFormElement.checked == true) {
            error = true;
        }
    }

    return error;
}

/**
 * Checkbox Group elements validation
 * @param checkboxGroupElement
 * @returns {boolean}
 */
const formCheckboxGroup = (checkboxGroupElement) => {
    let error = false;
    const checkboxOptions = checkboxGroupElement.querySelectorAll('input[type="checkbox"]');

    const hasAdditionalDetail = checkboxGroupElement.classList.contains('need-additional-detail');

    if(hasAdditionalDetail) {
        const parentFromField = checkboxGroupElement.closest('.form-field');
        const nextAdditionalDetail = parentFromField.nextSibling.nextElementSibling;

        var additionalFieldShow = false;
        for (const checkboxOption of checkboxOptions) {
            if (checkboxOption.checked == true && checkboxOption.classList.contains('trigger-additional-detail')) {
                additionalFieldShow = true;
            }
        }

        if (additionalFieldShow) {
            setAdditionalDetailVisibility(nextAdditionalDetail, true);
        } else {
            setAdditionalDetailVisibility(nextAdditionalDetail, false);
        }
    }

    // loop all checkbox items
    for (const checkboxOption of checkboxOptions) {
        if (checkboxOption.checked == true) {
            error = true;
        }
    }

    return error;
}

/**
 * Checkbox Group elements validation
 * @param selectGroupElement
 * @returns {boolean}
 */
const formSelectGroup = (selectGroupElement) => {
    let error = true;

    const selects = selectGroupElement.querySelectorAll('select');

    // Note: loop all select items
    for (const select of selects) {
        const defaultLabel = select.querySelectorAll('option')[0].innerText;
        const currentOption = select.parentElement.querySelector('.niceselect-text').innerText;

        if(currentOption === defaultLabel) {
            error = false;
            return;
        }
    }

    return error;
}

/**
 * Dropdown elements validation
 * @param dropdownElement
 * @returns {boolean}
 */
 const formDropdown = (dropdownElement) => {
    let error = false;

    if(dropdownElement.classList.contains('selected')) {
        error = true;
    }

    return error;
}

const langValue = document.documentElement.lang;
const validate = {
    settings: {
        valueMissingradio: langValue === 'cy' ? 'Dewiswch opsiwn' : 'Please select an option.',
        valueMissingselect: langValue === 'cy' ? 'Dewiswch opsiwn' : 'Please select an option.',
        valueMissingcheckbox: langValue === 'cy' ? 'Gwiriwch y blwch hwn i fynd yn eich blaen' : 'Please check this box to proceed.',
        valueMissingTextarea: langValue === 'cy' ? 'Ychwanegwch beth gynnwys at y darn hwn' : 'Please enter some contents for this field.',
        valueMissingCheckboxGroup: langValue === 'cy' ? 'Dewiswch opsiwn' : 'Please select an option.',
        valueMissingSelectGroup: langValue === 'cy' ? 'Dewiswch opsiwn' : 'Please select a date.',
        email: langValue === 'cy' ? 'Ychwanegwch gyfeiriad e-bost dilys' : 'Please enter a valid email address.',
        confirmEmail: langValue === 'cy' ? 'Gwnewch yn siŵr fod yr e-byst yr un fath' : 'Please ensure emails match.',
        generic: langValue === 'cy' ? 'Mae’n ofynnol cwblhau’r darn hwn' : 'This field is required.',
        tel: langValue === 'cy' ? 'Rhowch rif ffôn penodol e.e. 01491 825522' : 'Please specify a valid phone number e.g. 01491 825522.',
        postcode: langValue === 'cy' ? 'Rhowch god post penodol' : 'Please specify a valid postcode.',
        date: langValue === 'cy' ? 'Teipiwch ddyddiad dilys' : 'Please type in valid date.',
        messageTooShort: langValue === 'cy' ? 'Estynnwch y testun hwn i {minLength} o lythrennau neu fwy. Rydych yn defnyddio {length} o lythrennau ar hyn o bryd.' : 'Please lengthen this text to {minLength} characters or more. You are currently using {length} characters.',
        messageTooLong: langValue === 'cy' ? 'Cwtogwch y testun hwn i ddim mwy na {maxLength} o lythrennau. Rydych chi’n defnyddio {length} o lythrennau ar hyn o bryd.' : 'Please shorten this text to no more than {maxLength} characters. You are currently using {length} characters.',
        messageRangeOverflow: langValue === 'cy' ? 'Dewiswch werth nad yw’n fwy na {max}' : 'Please select a value that is no more than {max}.',
        messageRangeUnderflow: langValue === 'cy' ? 'Dewiswch werth nad yw’n llai na {min}' : 'Please select a value that is no less than {min}.',
        messagePatternMismatch: langValue === 'cy' ? 'Cydweddwch at y fformat ofynnol' : 'Please match the requested format.',
        beforeShowError: () => {},
        afterShowError: () => {},
        beforeRemoveError: () => {},
        afterRemoveError: () => {},
    },
    addErrorMsg: (field, errorMsg) => {
        field.setAttribute("aria-invalid", "true");
        let parentElement = field.closest('.form-group');
        let fieldErrorMsgElement = document.createElement('div');
        fieldErrorMsgElement.classList.add('error-message', 'toast-call-out', 'error');
        fieldErrorMsgElement.setAttribute("aria-hidden", "false");
        fieldErrorMsgElement.setAttribute("aria-live", "assertive");
        fieldErrorMsgElement.setAttribute("aria-relevant", "additions removals");

        if (!parentElement.lastElementChild.classList.contains('error-message')) {
            const fieldErrorMessage = document.createElement('p');
            fieldErrorMessage.innerText = errorMsg;
            const fieldIconElement = document.createElement('i');
            fieldIconElement.classList.add('icon', 'icon-error');

            fieldErrorMsgElement.appendChild(fieldIconElement);
            fieldErrorMsgElement.appendChild(fieldErrorMessage);
            parentElement.appendChild(fieldErrorMsgElement);
        }

        parentElement.classList.add('error');
    },
    removeErrorMsg: (field) => {
        field.setAttribute("aria-invalid", "false");
        const parentElement = field.closest('.form-group');

        if (parentElement.classList.contains('error')) {
            parentElement.classList.remove('error');
            const errorEl = parentElement.querySelector('.error-message');
            parentElement.removeChild(errorEl);
        }
    },
    hasError: (field) => {
        const localSettings = validate.settings;

        if (field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') return;

        const validity = field.validity;

        if (field.type === 'select-one') {
            return !formCheckSelect(field) ? localSettings.valueMissingselect : '';
        } else if (field.type === 'email') {
            return !validateEmail(field.value) ? localSettings.email : '';
        } else if (field.type === 'tel') {
            return !validatePhoneUK(field.value) ? localSettings.tel : '';
        } else if (field.type === 'radio') {
            return !formCheckRadio(field) ? localSettings.valueMissingradio : '';
        } else if (field.getAttribute('type') === 'checkbox-group') {
            return !formCheckboxGroup(field) ? localSettings.valueMissingCheckboxGroup : '';
        } else if (field.getAttribute('type') === 'select-group') {
            return !formSelectGroup(field) ? localSettings.valueMissingSelectGroup : '';
        } else if (field.getAttribute('type') === 'dropdown') {
            return !formDropdown(field) ? localSettings.valueMissingCheckboxGroup : '';
        } else if (field.getAttribute('input-data-type') === 'postcode') {
            return !validatePostcode(field.value) ? localSettings.postcode : '';
        }

        if (validity.valid) return;

        if (validity.valueMissing) {
            switch (field.type) {
                case 'select-one':
                    return !formCheckSelect(field) ? localSettings.valueMissingselect : '';

                case 'radio':
                    return !formCheckRadio(field) ? localSettings.valueMissingradio : '';

                case 'checkbox-group':
                    return !formCheckboxGroup(field) ? localSettings.valueMissingCheckboxGroup : '';

                case 'checkbox':
                    return !formCheckbox(field) ? localSettings.valueMissingcheckbox : '';

                case 'textarea':
                    return localSettings.valueMissingTextarea;

                default:
                    return localSettings.generic;
            }
        }

        if (validity.typeMismatch) {
            if (field.type === 'email' && !validateEmail(field.value)) return localSettings.email;
            if (field.type === 'tel' && !validatePhoneUK(field.value)) return localSettings.tel;
        }

        if (validity.tooShort) {
            return localSettings.messageTooShort.replace('{minLength}', field.getAttribute('minLength')).replace('{length}', field.value.length);
        }

        if (validity.tooLong) {
            return localSettings.messageTooLong.replace('{minLength}', field.getAttribute('maxLength')).replace('{length}', field.value.length);
        }

        if (validity.rangeOverflow) {
            return localSettings.messageRangeOverflow.replace('{max}', field.getAttribute('max'));
        }

        if (validity.rangeUnderflow) {
            return localSettings.messageRangeUnderflow.replace('{min}', field.getAttribute('min'));
        }

        if (validity.patternMismatch) {
            return localSettings.messagePatternMismatch;
        }

        return localSettings.generic;
    },
    removeError: (field) => {
        const localSettings = validate.settings;

        localSettings.beforeRemoveError(field);
        validate.removeErrorMsg(field);
        localSettings.afterRemoveError(field);
    },
    showError: (field, error) => {
        const localSettings = validate.settings;

        localSettings.beforeShowError(field, error);
        const errorMsgEl = field.parentNode.querySelectorAll('.error-message');
        if (!errorMsgEl.length) {
            validate.addErrorMsg(field, error);
        } else {
            errorMsgEl[0].querySelector('p').innerText = error;
        }
        localSettings.afterShowError(field, error);
    },
    inputHandler: function (event) {
        let error = "";
        if (!event.target.form && !event.target.classList.contains('dropdown-item')) return;

        // for checkbox group
        if (event.target.parentElement.parentElement.getAttribute('type') === 'checkbox-group') {
            error = validate.hasError(event.target.parentElement.parentElement);
        // for dropdown checkbox
        } else if (event.target.closest('.dropdown') && event.target.closest('.dropdown').getAttribute('type') === 'dropdown') {
            error = validate.hasError(event.target.closest('.dropdown'));
        } else if (event.target.parentElement.parentElement.getAttribute('type') === 'select-group') {
            error = validate.hasError(event.target.parentElement.parentElement);
        } else { // for rest of
            error = validate.hasError(event.target);
        }

        if (error) {
            validate.showError(event.target, error);
            return;
        }
        validate.removeError(event.target);
    },
};

export { validate };